import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;

  .content {
    display: flex;
    flex-direction: column;
    width: calc(100% - 4rem);
    margin: 1rem 2rem 2rem 2rem;
    height: fit-content;
  }

  .loading-container {
    margin-top: 2rem;
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
`;